import React, { FC } from 'react';
import { LinkProps } from '.';
import Link from '../CustomNextLink';

export const LinkTemplate: FC<LinkProps> = ({ className, href, icon, children }) => {
    return (
        <span className={className}>
            <Link href={href}>
                <a>
                    {icon ? <span dangerouslySetInnerHTML={{ __html: icon }}></span> : ''} {children}
                </a>
            </Link>
        </span>
    );
};

export default LinkTemplate;
